<template>
  <div class="main-bg">
    <div class="box">
      <v-form v-model="valid" lazy-validation>
        <form class="login_form" @submit.prevent="check()">
          <v-card-title class="justify-center">
            <v-avatar size="40">
              <img src="/all-assets/common/logo/cpb/cpbit.png" alt="CPB-IT" />
            </v-avatar>
            <b class="mx-3">CPB-IT Portal Register</b>
          </v-card-title>
          <v-card-text>
            <v-col>
              <v-text-field
                label="Login ID"
                placeholder="Enter Login ID"
                v-model="form.login"
                filled
                rounded
                dense
                required
                :rules="[rules.required, rules.counter]"
                counter
                maxlength="20"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                label="Password"
                placeholder="Enter Password"
                hint="At least 3 characters"
                filled
                rounded
                dense
                required
                counter
                @click:append="show1 = !show1"
              ></v-text-field>
            </v-col>

            <v-col>
              <v-btn
                block
                rounded
                :loading="loading"
                color="success"
                type="submit"
                :disabled="!valid"
              >
                Register Check
                <v-icon right>mdi-login</v-icon>
              </v-btn>
            </v-col>

            <div class="text-center mt-4">
              Do you want to back ?
              <router-link :to="{ name: 'Login' }" class="text_color">
                <v-btn class="teal--text" plain text>
                  <v-icon size="16">mdi-login</v-icon>Login
                </v-btn>
              </router-link>
            </div>

            <!-- Footer  -->
            <div>
              <p class="d-flex align-items-center justify-content-center mt-4 footer_text">
                <img
                  src="https://asset.cpbangladesh.com/documents/cpbit_96_96_20220130055505qOomPLPI0l.png"
                  alt="cpb-it"
                  height="20px"
                />
                &nbsp;Powered by CPB-IT
              </p>
            </div>
          </v-card-text>
        </form>
      </v-form>
    </div>

    <register-form :key="registerRerendarKey" v-if="registerFrmShow" :adData="adData"></register-form>
  </div>
</template>

<script>
import Form from "vform";
import registerForm from "./register_form.vue";
export default {
  components: {
    "register-form": registerForm
  },
  data() {
    return {
      announce: true,

      passwordType: false,
      loading: false,
      password: null,
      registerFrmShow: false,

      adData: "",

      // v-form
      valid: false,
      show1: false,
      passwordType: false,
      loading: false,
      password: null,

      // Form
      form: new Form({
        login: "",
        password: ""
      }),

      rules: {
        required: value => !!value || "Required.",
        counter: value => value.length <= 20 || "Max 20 characters",
        min: v => v.length >= 3 || "Min 3 characters",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },

  methods: {
    // check
    async check() {
      this.loading = true;

      // request send and get response
      const response = await this.form.post("/register_check");

      //console.log(response.data)
      // Input field make empty
      this.form.reset();
      this.form.errors.clear();

      if (response.data.status == "success") {
        this.loading = false;

        if (response.data.code == 202) {
          // Data found in local server User tbl
          Swal.fire({
            icon: response.data.icon,
            title: response.data.msg
          }).then(() => {
            // After click ok then redirect
            // window.location.href = "/login"
            this.$router.push({ name: "Login" });
          });
        } else if (response.data.code == 208) {
          // Data found in local server UserRegister tbl
          Swal.fire({
            icon: response.data.icon,
            title: response.data.msg
          }).then(() => {
            // After click ok then redirect
            this.$router.push({ name: "Login" });
          });
        } else if (response.data.code == 203) {
          // Data found in local server UserRegister tbl
          Swal.fire({
            icon: response.data.icon,
            title: response.data.msg
          }).then(() => {
            // After click ok then redirect
            this.$router.push({ name: "Login" });
          });
        } else if (response.data.code == 200) {
          // Data found in AD Server
          // Show register form
          this.registerFrmShow = true;
          this.registerRerendarKey++;
          this.adData = response.data.data;
          //   console.log(response.data.data);
          // Toast alert
          Toast.fire({
            icon: response.data.icon,
            title: response.data.msg
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Successfully Done"
          });
        }
      } else {
        this.loading = false;
        this.registerFrmShow = false;
        this.adData = "";
        // swal alert
        Swal.fire({
          icon: response.data.icon,
          title: response.data.msg,
          customClass: "text-danger"
        });
        // Swal.fire("Failed!", data.message, "warning");
        console.log(response.data);
      }
    }
  }
};
</script>

<style scoped>
.main-bg {
  background: #23242a;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  position: relative;
  width: 380px;
  height: 450px;
  background: #131212;
  border-radius: 8px;
  overflow: hidden;
}

.box::before {
  content: "";
  z-index: 1;
  position: absolute;
  top: -50%;
  left: -50%;
  width: 440px;
  height: 470px;
  transform-origin: bottom right;
  background: linear-gradient(0deg, transparent, #84ffff, #14e7e7);
  animation: animate 6s linear infinite;
}
.box::after {
  content: "";
  z-index: 1;
  position: absolute;
  top: -50%;
  left: -50%;
  width: 380px;
  height: 450px;
  transform-origin: bottom right;
  background: linear-gradient(0deg, transparent, #48da78, #07a556);
  animation: animate 6s linear infinite;
  animation-delay: -3s;
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.login_form {
  position: absolute;
  inset: 4px;
  background: #f8f8fa;
  border-radius: 8px;
  z-index: 2;
  display: flex;
  flex-direction: column;
}

.links {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.links a {
  margin: 10px 0;
  font-size: 0.95em;
  color: #8f8f8f;
  text-decoration: none;
}

.footer_text {
  font-size: 0.75em;
  color: #8f8f8f;
}

.links :hover,
.links a:hover,
.links a:nth-child(2) {
  color: #0f0f0f;
}
</style>
